import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import VideoGallerySection from '@/pages/home/components/VideoGallerySection';

export default function GalleryPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopBar />
      <Navbar />
      <main>
        <section className="py-16 md:py-20 bg-secondary-800">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-2xl md:text-5xl text-background-50 mb-4">Reklam Tanıtımlarımız</h1>
            <p className="text-background-50/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              Fineco Isı Pompası ve Atak Sistem Enerji hizmetleri hakkında hazırladığımız tanıtım videolarını izleyebilir, detaylı bilgi için bizimle iletişime geçebilirsiniz.
            </p>
          </div>
        </section>
        <VideoGallerySection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}